import React, {Fragment} from 'react';
import EditorField from "./editor/editor";
import {exportToMustache, importFromMustache} from "./editor/slate/replacement/Mustache";
import classNames from "classnames";
import strip_tags from "locutus/php/strings/strip_tags";
import MustacheElements from "./editor/plugins/replacement/Mustache";

export default class Tags extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <EditorField
                    {...this.props}
                    defaultValue={''}
                    formatter={false}
                    className={classNames("rt-rich-tags", this.props.oneLine ? "one-line" : "")}
                    toolbar={['variable']}
                    elements={MustacheElements}
                    disableNewLine={this.props.oneLine}
                    placeholder={this.props.placeholder}
                    import={importFromMustache}
                    export={exportToMustache}
                />
            </Fragment>
        );
    }
}